import * as actions from './customField.actions';
import { EntityState, createEntityAdapter, Update } from '@ngrx/entity';
import { createFeatureSelector, createSelector, Store } from '@ngrx/store';
import { CustomFieldModel } from '@smarttask-common/src/lib/models/CustomField/Core/CustomFieldModel';

export const customFieldAdapter = createEntityAdapter<CustomFieldModel>({
    selectId: (x) => x.custom_field_id,
});
export interface CustomFieldState extends EntityState<CustomFieldModel> {
    selected_custom_field_id: string;
}

export const initialState: CustomFieldState = customFieldAdapter.getInitialState({
    selected_custom_field_id: undefined,
});

export function CustomFieldReducers(state: CustomFieldState = initialState, action: actions.CustomFieldActions) {
    switch (action.type) {
        case actions.CustomFieldActionTypes.UPDATE_SELECTED_ID:
            state = { ...state, selected_custom_field_id: action.selected_custom_field_id };
            //console.log(state);
            return state;

        case actions.CustomFieldActionTypes.ADD_CUSTOM_FIELD:
            return customFieldAdapter.addOne(action.custom_field, state);

        case actions.CustomFieldActionTypes.ADD_CUSTOM_FIELDS:
            return customFieldAdapter.addMany(action.custom_fields, state);

        case actions.CustomFieldActionTypes.UPSERT_CUSTOM_FIELD:
            return customFieldAdapter.upsertOne(action.custom_field, state);

        case actions.CustomFieldActionTypes.UPSERT_CUSTOM_FIELDS:
            return customFieldAdapter.upsertMany(action.custom_fields, state);

        case actions.CustomFieldActionTypes.UPDATE_CUSTOM_FIELD:
            return customFieldAdapter.updateOne(action.custom_field, state);

        case actions.CustomFieldActionTypes.UPDATE_CUSTOM_FIELDS:
            return customFieldAdapter.updateMany(action.custom_fields, state);

        case actions.CustomFieldActionTypes.DELETE_CUSTOM_FIELD:
            // if(state.selectedCustomFieldId == action.id){
            //   state.selectedCustomFieldId = undefined;
            // }
            return customFieldAdapter.removeOne(action.id, state);

        case actions.CustomFieldActionTypes.DELETE_CUSTOM_FIELDS:
            // if(action.ids.indexOf(state.selectedCustomFieldId) > -1){
            //   state.selectedCustomFieldId = undefined;
            // }
            return customFieldAdapter.removeMany(action.ids, state);

        case actions.CustomFieldActionTypes.DELETE_ALL_CUSTOM_FIELDS:
            return customFieldAdapter.removeMany(action.ids, state);

        case actions.CustomFieldActionTypes.DELETE_ALL:
            return customFieldAdapter.removeAll(state);

        default:
            return state;
    }
}

export const getCustomFieldState = createFeatureSelector<CustomFieldState>('customField');

export const { selectIds, selectEntities, selectAll, selectTotal } = customFieldAdapter.getSelectors(getCustomFieldState);

const getSelectedCustomFieldIdState = (state: CustomFieldState) => {
    return state.selected_custom_field_id;
};
export const getSelectedCustomFieldId = createSelector(getCustomFieldState, getSelectedCustomFieldIdState);

export const getSelectedCustomField = createSelector(getCustomFieldState, (state: CustomFieldState) => {
    if (state.selected_custom_field_id == undefined) {
        return undefined;
    }
    return state.entities[state.selected_custom_field_id];
});
